import { useCallback, useRef } from 'react';
import { DATA_TRANSFER, EMBEDDED_READY } from '../constants/dataTransfer';
import { isValidMessage } from '../util/dataTransfer';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const DataTransferTab = ({
  fromLocation,
  tabUrl,
  data,
  children,
  _window = window
}) => {
  const targetWindowRef = useRef(undefined);
  const handleMessage = useCallback(event => {
    const {
      data: {
        type
      }
    } = event;
    if (!isValidMessage(event, (targetWindowRef.current || {
      origin: ''
    }).origin)) {
      return;
    }
    if (type === EMBEDDED_READY) {
      if (targetWindowRef.current) {
        targetWindowRef.current.postMessage({
          type: DATA_TRANSFER,
          fromLocation,
          data
        });
      }
    }
  }, [data, fromLocation]);
  const handleClick = useCallback(() => {
    targetWindowRef.current = _window.open(tabUrl, '_blank');
    if (targetWindowRef.current) {
      targetWindowRef.current.addEventListener('message', handleMessage);
    }
  }, [tabUrl, handleMessage, _window]);
  if (typeof children !== 'function') {
    throw new Error('children of DataTransferTab must be a function');
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children(handleClick)
  });
};
export default DataTransferTab;